import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "decrement", "increment"]

  connect() {
    this.refresh()
  }

  increment() {
    this.step(1)
  }

  decrement() {
    this.step(-1)
  }

  step(delta) {
    const input = this.inputTarget
    const min = Number(input.min || 1)
    const max = Number(input.max || Infinity)
    const next = Math.min(max, Math.max(min, Number(input.value || min) + delta))

    if (next === Number(input.value)) return

    input.value = next
    input.dispatchEvent(new Event("input", { bubbles: true }))
    this.refresh()
  }

  refresh() {
    const input = this.inputTarget
    const min = Number(input.min || 1)
    const max = Number(input.max || Infinity)
    const value = Number(input.value)

    if (this.hasDecrementTarget) this.decrementTarget.disabled = value <= min
    if (this.hasIncrementTarget) this.incrementTarget.disabled = value >= max
  }
}
